<template>
  <v-app>
    <v-main class="login-container" :style="backgroundStyle">
      <Loading :isActive="loading" />

      <!-- Overlay escuro -->
      <div class="overlay-dark"></div>

      <v-container fluid class="fill-height">
        <v-row justify="center" align="center">
          <v-col cols="12" lg="10" xl="8">
            <v-fade-transition>
              <v-card
                v-if="true"
                class="login-card"
                elevation="24"
              >
                <v-row no-gutters>
                  <!-- Coluna Promocional (Esquerda) -->
                  <v-col
                    cols="12"
                    md="6"
                    class="promotional-section d-none d-md-flex"
                    :style="promotionalBackground"
                  >
                    <div class="promotional-overlay">
                      <div class="promotional-content">
                        <v-slide-y-transition>
                          <div v-if="true" class="text-white">
                            <!-- Badge -->
                            <div class="badge-novidade mb-4">
                              ✨ Painel Administrativo
                            </div>

                            <!-- Título -->
                            <h1 class="promotional-title mb-4">
                              Gestão Completa
                            </h1>

                            <!-- Descrição -->
                            <p class="promotional-description mb-6">
                              Controle total das suas aplicações de venda.
                            </p>
                          </div>
                        </v-slide-y-transition>
                      </div>
                    </div>
                  </v-col>

                  <!-- Coluna do Formulário (Direita) -->
                  <v-col cols="12" md="6">
                    <div class="form-section">
                      <!-- Logo -->
                      <div class="text-center mb-6">
                        <img
                          :src="logo"
                          alt="Logo"
                          class="form-logo"
                        />
                      </div>

                      <!-- Cabeçalho -->
                      <div class="text-center mb-8">
                        <h2 class="form-title">Bem-vindo</h2>
                        <p class="form-subtitle">
                          Faça login para continuar
                        </p>
                      </div>

                      <!-- Formulário -->
                      <v-form @submit.prevent="onSubmit">
                        <v-text-field
                          v-model="user"
                          label="Matrícula, CPF ou Email"
                          outlined
                          dense
                          required
                          autofocus
                          autocomplete="username email"
                          class="mb-2"
                          :error-messages="loginError ? ' ' : ''"
                        ></v-text-field>

                        <v-text-field
                          v-model="pass"
                          label="Senha"
                          outlined
                          dense
                          required
                          autocomplete="current-password"
                          class="mb-4"
                          :type="showPassword ? 'text' : 'password'"
                          :error-messages="loginError ? ' ' : ''"
                        >
                          <template v-slot:append>
                            <v-icon
                              small
                              @click="showPassword = !showPassword"
                              style="cursor: pointer"
                            >
                              <fa-icon :icon="showPassword ? 'eye-slash' : 'eye'" />
                            </v-icon>
                          </template>
                        </v-text-field>

                        <!-- Mensagem de Erro -->
                        <v-fade-transition>
                          <v-alert
                            v-if="loginError"
                            type="error"
                            dense
                            text
                            class="mb-4"
                          >
                            {{ loginError }}
                          </v-alert>
                        </v-fade-transition>

                        <!-- Botão de Login -->
                        <v-btn
                          type="submit"
                          color="primary"
                          x-large
                          block
                          elevation="4"
                          class="login-button mb-4"
                          :loading="loading"
                        >
                          <fa-icon icon="sign-in-alt" class="mr-2" />
                          Entrar
                        </v-btn>

                        <!-- API URL Change -->
                        <div class="mt-4">
                          <ApiUrlChange />
                        </div>
                      </v-form>

                      <!-- Footer -->
                      <div class="footer-section mt-8">
                        <v-divider class="mb-4"></v-divider>
                        <p class="text-center text--secondary caption mb-0">
                          Desenvolvido por
                          <a
                            href="https://versotech.com.br"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="versotech-link"
                          >
                            Versotech®
                          </a>
                        </p>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-fade-transition>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import config from "../../config";
import ApiUrlChange from "../../components/ApiUrlChange.vue";
import { getToken } from "@/helpers/apiRequest";
import { loadCargas } from "../../helpers/cargas";
import promotionalBgImage from "@/assets/images/admin-bg.jpeg";

export default {
  name: "login",
  components: {
    ApiUrlChange,
  },
  data() {
    return {
      logo: config.api + "/images/logo/s/ADMIN",
      background: config.api + "/images/background/ADMIN",
      promotionalBg: promotionalBgImage,
      user: "",
      pass: "",
      loginError: false,
      loading: false,
      showPassword: false,
    };
  },
  computed: {
    backgroundStyle() {
      return {
        backgroundImage: `url(${this.background})`,
      };
    },
    promotionalBackground() {
      return {
        backgroundImage: `url(${this.promotionalBg})`,
      };
    },
  },
  methods: {
    onSubmit() {
      this.loading = true;
      this.loginError = false;

      getToken({ cpf: this.user, senha: this.pass })
        .then((json) => {
          localStorage.setItem("token", json.token);
          loadCargas(
            json.token,
            () => {
              this.$router.push({ name: "home" });
              this.loading = false;
            },
            (err) => {
              this.loading = false;
              this.loginError = err.message;
            }
          );
        })
        .catch((error) => {
          this.loading = false;
          this.loginError = error.message;
        });
    },
  },
};
</script>

<style scoped>
/* Container Principal */
.login-container {
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}

/* Overlay Escuro */
.overlay-dark {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1;
}

.login-container .container {
  position: relative;
  z-index: 2;
}

/* Card Principal */
.login-card {
  border-radius: 24px !important;
  overflow: hidden;
  background: transparent !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3) !important;
}

/* Seção Promocional (Esquerda) */
.promotional-section {
  min-height: 600px;
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 48px;
}

.promotional-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(0, 0, 0, 0.75) 0%,
    rgba(0, 0, 0, 0.6) 100%
  );
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 48px;
}

.promotional-content {
  position: relative;
  z-index: 2;
}

.badge-novidade {
  display: inline-block;
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  padding: 8px 16px;
  border-radius: 12px;
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.promotional-title {
  font-size: 2.5rem;
  font-weight: 700;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  line-height: 1.2;
}

.promotional-description {
  font-size: 1.125rem;
  line-height: 1.6;
  text-shadow: 0 1px 5px rgba(0, 0, 0, 0.3);
  opacity: 0.95;
}

/* Seção do Formulário (Direita) */
.form-section {
  padding: 48px 40px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px) saturate(100%);
  -webkit-backdrop-filter: blur(10px) saturate(100%);
  min-height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.form-logo {
  max-width: 200px;
  height: auto;
}

.form-title {
  font-size: 2rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.form-subtitle {
  color: #666;
  font-size: 0.95rem;
  margin-bottom: 0;
}

/* Botão de Login */
.login-button {
  font-size: 1rem !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px;
  padding: 24px 0 !important;
  transition: all 0.3s ease !important;
}

.login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(25, 118, 210, 0.4) !important;
}

/* Footer */
.footer-section {
  margin-top: auto;
}

.versotech-link {
  color: #2298a3;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.2s ease;
}

.versotech-link:hover {
  text-decoration: underline;
  color: #1a7a82;
}

/* Responsivo */
@media (max-width: 960px) {
  .form-section {
    padding: 32px 24px;
    min-height: auto;
  }

  .promotional-title {
    font-size: 2rem;
  }
}

@media (max-width: 600px) {
  .form-section {
    padding: 24px 16px;
  }

  .form-logo {
    max-width: 160px;
  }

  .form-title {
    font-size: 1.75rem;
  }
}
</style>
